var _path, _rect, _rect2, _g, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 63,
    viewBox: "0 0 67 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48454 40.1542C35.4836 41.0561 17.55 4.71961 39.8682 6.86484C99.1848 12.5668 45.8744 62.7887 23.8515 62.7734C-3.1315 62.7531 -4.33275 39.7771 7.48454 40.1542Z",
    fill: "#B6FFE4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.8574,
    y: 20.6631,
    width: 38.3081,
    height: 38.3081,
    rx: 8,
    transform: "rotate(-10.3352 14.8574 20.6631)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_416_8214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 15,
    width: 43,
    height: 43
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8574,
    y: 20.6631,
    width: 38.3081,
    height: 38.3081,
    rx: 8,
    transform: "rotate(-10.3352 14.8574 20.6631)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_416_8214)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2349,
    y: 27.3477,
    width: 38.3081,
    height: 38.3081,
    rx: 10,
    transform: "rotate(-10.3352 10.2349 27.3477)",
    fill: "#68F9C5"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8574,
    y: 20.6631,
    width: 38.3081,
    height: 38.3081,
    rx: 8,
    transform: "rotate(-10.3352 14.8574 20.6631)",
    stroke: "#333333",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7383 31.5653L27.3078 29.2436L29.6295 28.8131C30.2706 28.6942 30.694 28.0781 30.5751 27.437C30.4562 26.7959 29.8401 26.3725 29.199 26.4914L26.8773 26.9219L26.4468 24.6002C26.3279 23.9591 25.7118 23.5357 25.0707 23.6546C24.4295 23.7735 24.0062 24.3896 24.1251 25.0307L24.5556 27.3524L22.2339 27.7829C21.5927 27.9018 21.1694 28.5179 21.2883 29.159C21.4071 29.8002 22.0233 30.2235 22.6644 30.1046L24.9861 29.6741L25.4166 31.9958C25.5355 32.637 26.1516 33.0603 26.7927 32.9415C27.4338 32.8226 27.8572 32.2065 27.7383 31.5653Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5684 24.1006C48.4495 23.4594 47.8334 23.0361 47.1923 23.155L41.388 24.2312C40.7469 24.3501 40.3235 24.9662 40.4424 25.6073C40.5613 26.2485 41.1774 26.6718 41.8185 26.5529L47.6228 25.4767C48.2639 25.3578 48.6873 24.7417 48.5684 24.1006Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.443 44.996C52.3241 44.3548 51.708 43.9315 51.0669 44.0504L45.2626 45.1266C44.6215 45.2455 44.1981 45.8616 44.317 46.5027C44.4359 47.1439 45.052 47.5672 45.6931 47.4483L51.4974 46.3721C52.1385 46.2532 52.5618 45.6371 52.443 44.996Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5819 40.3525C51.4631 39.7114 50.847 39.2881 50.2058 39.4069L44.4016 40.4832C43.7604 40.6021 43.3371 41.2182 43.456 41.8593C43.5748 42.5004 44.1909 42.9238 44.8321 42.8049L50.6363 41.7286C51.2775 41.6098 51.7008 40.9937 51.5819 40.3525Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2668 45.4808L27.7341 47.1761L26.0387 49.6434C25.6694 50.1808 25.8057 50.9158 26.3431 51.285C26.8805 51.6543 27.6155 51.518 27.9848 50.9806L29.6802 48.5134L32.1474 50.2088C32.6848 50.578 33.4198 50.4417 33.7891 49.9043C34.1584 49.3669 34.0221 48.632 33.4847 48.2627L31.0175 46.5673L32.7128 44.1001C33.0821 43.5627 32.9458 42.8277 32.4084 42.4584C31.871 42.0891 31.136 42.2254 30.7667 42.7628L29.0714 45.23L26.6041 43.5347C26.0667 43.1654 25.3317 43.3017 24.9624 43.8391C24.5932 44.3765 24.7294 45.1115 25.2668 45.4808Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7007 17.2266L40.5734 54.9131",
    stroke: "#333333",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.981 32.6348L18.2944 39.5075",
    stroke: "#333333",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0894 11.7217L15.692 14.7698",
    stroke: "#0BAD73",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89593 14.2418L11.0761 17.428",
    stroke: "#0BAD73",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89669 23.7345L9.94482 23.1318",
    stroke: "#0BAD73",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath);
export default __webpack_public_path__ + "static/media/math.e31085cceeebdfb64f27b9917a7b50db.svg";
export { ForwardRef as ReactComponent };